define([
    "./autoRefreshModule",
    "./nlgAutoRefresh"
], function () {
});